<nav class="bg-primary text-primary-contrast relative flex min-h-[116px] items-center lg:static">
  <div class="container flex items-center">
    @if (isMobileSize) {
      <img
        src="assets/images/sapientialogopiccolo2@3x.webp"
        alt="Sapientia Logo"
        class="mr-0 h-20 cursor-pointer"
        (click)="goToHome()"
      />
    } @else {
      <img
        [src]="'assets/images/logo_light.png'"
        alt="Sapientia Logo"
        class="mr-4 h-10 cursor-pointer"
        (click)="goToHome()"
      />
    }
    <!-- Hamburger Menu Start -->
    <div class="ml-auto flex gap-4 lg:hidden">
      <button
        pButton
        class="rounded-lg bg-white p-3 text-[#394A84]"
        type="button"
        (click)="toggleHamburgerMenu()"
      >
        <i class="pi pi-search text-xl font-semibold"></i>
      </button>
      <!-- Hamburger Menu End -->
      <button
        pButton
        class="rounded-lg bg-indigo-500"
        type="button"
        (click)="accountMenu.toggle($event)"
      >
        <i class="pi pi-bars text-xl font-semibold"></i>
      </button>
      <button
        pButton
        class="bg-secondary dark:bg-primary-variant text-primary rounded-lg shadow-none"
        type="button"
        (click)="switchTheme()"
      >
        @if (localTheme === "LIGHT") {
          <i class="pi pi-sun text-xl font-semibold"></i>
        } @else {
          <i class="pi pi-moon text-xl font-semibold"></i>
        }
      </button>
    </div>
    <!-- Hamburger Menu End -->
    <div
      class="absolute top-full left-0 z-10 w-full grow items-center lg:static lg:flex lg:border lg:border-0 lg:shadow-none"
      [ngClass]="{ hidden: !isMenuVisible && isMobileSize }"
    >
      <ul
        class="bg-primary m-0 flex grow list-none flex-col gap-2 p-0 select-none lg:flex-row lg:items-center"
      >
        <li class="flex grow p-4 lg:py-2">
          <p-splitButton
            [label]="
              selectedCategory() !== undefined
                ? selectedCategory()?.label
                : ('header.All' | translate)
            "
            [model]="categoryOptions"
            #splitButton
            severity="secondary"
            class="hidden md:block"
            styleClass="split-button-text border-tr"
            (onClick)="selectCategory(selectedCategory())"
            [appendTo]="splitButton"
          ></p-splitButton>
          <p-iconfield styleClass="w-full flex items-center">
            @if (searchFilter()) {
              <p-inputicon styleClass="pi pi-times cursor-pointer" (click)="clearQuery()" />
            }
            <input
              #inputSearch
              pInputText
              type="text"
              placeholder="{{ 'header.searchSapientia' | translate }}"
              [(ngModel)]="searchFilter"
              class="input-split-button-corners w-full md:rounded-tl-none md:rounded-bl-none"
              (keyup.enter)="searchWithQuery()"
            />
            <p-inputicon
              styleClass="pi pi-search cursor-pointer"
              (click)="searchWithQuery()"
              [pTooltip]="inputSearch.value.length < 1 && ('header.toolTipResearch' | translate)"
              tooltipPosition="bottom"
            />
          </p-iconfield>
        </li>
        <!-- Account -->
        <li class="hidden lg:block">
          <button
            pButton
            class="relative flex flex-col items-start gap-0 overflow-visible text-sm font-semibold hover:border-transparent hover:bg-transparent"
            (click)="accountMenu.toggle($event)"
          >
            @if (sessionService.isLogged && !sessionService.isLoginGuest()) {
              <small class="max-w-[85px] truncate font-light">
                <i class="pi pi-user"></i>
                {{ "header.Hello" | translate }}
                {{ sessionService.user()?.firstName }}</small
              >
              <span class="flex items-center gap-1"
                >{{ "header.Account" | translate }}<i class="pi pi-angle-down text-sm"></i
              ></span>
            } @else {
              <small class="font-light">
                <i class="pi pi-user"></i>
                {{ "header.Welcome" | translate }}</small
              >
              <span class="flex items-center gap-1"
                >{{ "header.SignIn" | translate }}<i class="pi pi-angle-down text-sm"></i
              ></span>
            }
          </button>
        </li>
        <!-- Cart -->
        <li class="hidden lg:block">
          @if (cartService.isLoadingCart) {
            <i class="pi pi-spin pi-spinner" style="font-size: 1.5rem"></i>
          } @else {
            <button
              pButton
              icon="pi pi-shopping-cart"
              class="relative overflow-visible text-sm font-semibold hover:border-transparent hover:bg-transparent"
              (click)="goToCart()"
              pBadge
              [badgeDisabled]="cartService.numberOfArticles() === 0"
              [value]="cartService.numberOfArticles()"
              badgeStyleClass="bg-secondary text-on-secondary top-1.5 right-1.5 h-5 w-5 flex items-center"
            >
              {{ "header.Cart" | translate }}
            </button>
          }
        </li>
        <!-- Divider (hidden on mobile) -->
        <li
          class="hidden lg:mr-2 lg:ml-4 lg:block lg:h-12 lg:border lg:border-white dark:border-black"
        ></li>
        <!-- Language selection -->
        <li class="mb-2 hidden lg:mb-0 lg:block">
          <p-select
            [options]="languages"
            [(ngModel)]="selectedLanguage"
            placeholder="Lingua"
            class="border-0 bg-transparent shadow-none"
            (onChange)="selectLanguage($event)"
          >
            <ng-template pTemplate="selectedItem">
              @if (selectedLanguage) {
                <div class="flex items-center gap-2">
                  <span [class]="'flag flag-' + selectedLanguage.code.toLowerCase()"></span>
                  <span class="dark:text-primary-contrast text-sm text-white">{{
                    selectedLanguage.name
                  }}</span>
                </div>
              }
            </ng-template>
            <ng-template let-language pTemplate="item">
              <div class="flex items-center gap-2">
                <span [class]="'flag flag-' + language.code.toLowerCase()"></span>
                <span>{{ language.name }}</span>
              </div>
            </ng-template>
          </p-select>
        </li>
        <!--Theme switch -->
        <li class="hidden lg:block">
          <button
            pButton
            class="bg-secondary dark:bg-primary-variant text-primary rounded-lg p-2 shadow-none"
            type="button"
            (click)="switchTheme()"
          >
            @if (localTheme === "LIGHT") {
              <i class="pi pi-sun font-semibold"></i>
            } @else {
              <i class="pi pi-moon font-semibold"></i>
            }
          </button>
        </li>
      </ul>
    </div>
  </div>
</nav>
<p-menu
  #accountMenu
  [model]="accountOptions"
  [popup]="true"
  styleClass="w-[178px] rounded-xl border-primary-variant"
>
  @if (accountOptions.length === 0) {
    <ng-template #start>
      <div class="lg:pt-auto flex flex-col justify-center gap-5 p-3 pt-4 pb-1 lg:gap-3">
        <div>
          <button
            pButton
            class="bg-secondary border-secondary w-full rounded-xl p-1.5 px-2 shadow-md shadow-gray-300 lg:w-auto dark:shadow-gray-800"
            type="button"
          >
            <span
              class="text-on-secondary font-w font-bold"
              routerLink="/login"
              (click)="accountMenu.toggle($event)"
              >{{ "header.signInNow" | translate }}</span
            >
          </button>
        </div>
        <div class="flex flex-col text-sm lg:pr-3">
          <span>
            {{ "header.notRegistered" | translate }}
            <a
              class="text-primary-variant font-bold underline"
              routerLink="/registration"
              (click)="accountMenu.toggle($event)"
              >{{ "header.clickHere" | translate }}</a
            ></span
          >
        </div>
      </div>
    </ng-template>
  }
  <ng-template #item let-item>
    <a pRipple class="p-menu-item-link flex items-center justify-between">
      <span>{{ item.label | translate }}</span>
      <i [class]="item.icon"></i>
    </a>
  </ng-template>
  @if (isMobileSize) {
    <ng-template #end>
      <div class="p-1">
        <a
          pRipple
          icon="pi pi-shopping-cart"
          class="p-menu-item-link flex items-center justify-between"
          (click)="goToCart()"
        >
          {{ "header.Cart" | translate }}
          <i class="pi pi-shopping-cart text-sm"></i>
        </a>
        <p-listbox
          [options]="languages"
          [(ngModel)]="selectedLanguage"
          optionLabel="name"
          class="w-full border-0 md:w-56"
          (onChange)="selectLanguage($event)"
        >
          <ng-template let-country #item>
            <div class="flex items-center gap-2">
              <img
                src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                [class]="'flag flag-' + country.code.toLowerCase()"
                style="width: 18px"
              />
              <div>{{ country.name }}</div>
            </div>
          </ng-template>
        </p-listbox>
      </div>
    </ng-template>
  }
</p-menu>
